// DeviceDetailModal.js
import { Modal, ModalHeader, ModalBody, ModalContent } from "@heroui/react";
import { useEffect, useState } from "react";
import ClimatisationDeviceDetailComponent from "./climatisationDeviceDetailComponent";

const ClimatisationDeviceDetailModal = ({ isOpen, onClose, building, unit, climatisationInfo, climatisationDevice, fetchDevices }: any) => {
    const [localDevice, setLocalDevice] = useState(climatisationDevice);

    useEffect(() => {
        setLocalDevice(climatisationDevice);
    }, [climatisationDevice]);

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="5xl"
            shouldBlockScroll={true}
            isDismissable={true}
            scrollBehavior="inside"
            backdrop="blur"
            className="p-8"
        >
            <ModalContent className="flex flex-col gap-4 font-normal text-neutral-primary">
                <ModalHeader className="flex flex-row items-center justify-between p-0 font-normal">
                    <p>{building?.id || unit?.id} - Toestel detail</p>
                </ModalHeader>
                <ModalBody className="px-0">
                    <ClimatisationDeviceDetailComponent
                        climatisationInfo={climatisationInfo}
                        handleCloseParent={onClose}
                        climatisationDevice={localDevice}
                        fetchDevices={fetchDevices}
                        unit={unit}
                        building={building}
                    />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default ClimatisationDeviceDetailModal;
